/* eslint-disable prettier/prettier */
import { borderRadius } from '@mui/system';
import styled from '@mui/system/styled';

export const WelcomeDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  '& .title': {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '32.78px',
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: '-0.15px',
    textAlign: 'center',
    marginBottom: 3,
  },
  '& .subTitle': {
    fontWeight: 600,
    fontSize: 16,
    textAlign: 'center',
    lineHeight: '22px',
    color: '#616161',
    marginBottom: 30,
  },

  '& .cardSubHeaderText': {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '143%',
    textAlign: 'center',
    letterSpacing: '0.17px',
    color: 'rgba(0, 0, 0, 0.6)',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0,
  },
  '& .cardContent': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .skipLabel': {
    fontSize: '13px',
    fontWeight: '500',
  },
});
